import { render, staticRenderFns } from "./HttpDeleteButton.vue?vue&type=template&id=f008d23c&"
import script from "./HttpDeleteButton.vue?vue&type=script&lang=js&"
export * from "./HttpDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports